import React, { useState } from "react";
import "./form-nav.css";

const Form = () => {

  // Store form data (name, phone, course)
  const [formData, setFormData] = useState({
    name: "",
    course: "",
    phone: "",
  });

  // This function runs when user types in input fields
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update the specific field value
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // This function runs when form is submitted
  const handleSubmit = (e) => {
    e.preventDefault(); // stop page reload

    // Create WhatsApp message
    const message = encodeURIComponent(
      `Get in Touch:
Name: ${formData.name}
Phone: ${formData.phone}
Course: ${formData.course}`
    );

    // Open WhatsApp with message
    const url = `https://wa.me/91 81780 67868 ?text=${message}`;
    window.open(url, "_blank");
  };

  return (
    <div className="container">
      <h1>Get in Touch</h1>

      {/* Form starts */}
      <form className="form-box-content" onSubmit={handleSubmit}>
        <h2>Register Now</h2>

        {/* Name Input */}
        <label>Name <span>*</span></label>
        <input
          type="text"
          name="name"
          placeholder="Your full name.."
          value={formData.name}
          onChange={handleChange}
          required
        />

        {/* Phone Input */}
        <label>Phone Number <span>*</span></label>
        <div className="phone-box">
          <input
            type="text"
            name="phone"
            placeholder="Enter phone number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        {/* Course Input */}
        <label>Course <span>*</span></label>
        <input
          type="text"
          name="course"
          placeholder="Enter your course.."
          value={formData.course}
          onChange={handleChange}
          required
        />

        {/* Submit Button */}
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default Form;